import { CurrencyStateTypes, CurrencyActionTypes } from "./Currency.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: CurrencyStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const CurrencyReducer = (
  state: CurrencyStateTypes = INITIAL_STATE,
  action: any
): CurrencyStateTypes => {
  switch (action.type) {
    case CurrencyActionTypes.FETCH_ALL_CURRENCY:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case CurrencyActionTypes.FETCH_ALL_CURRENCY_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case CurrencyActionTypes.FETCH_ALL_CURRENCY_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case CurrencyActionTypes.FETCH_ALL_CURRENCY_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case CurrencyActionTypes.FETCH_ONE_CURRENCY:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case CurrencyActionTypes.FETCH_ONE_CURRENCY_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case CurrencyActionTypes.FETCH_ONE_CURRENCY_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case CurrencyActionTypes.FETCH_ONE_CURRENCY_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default CurrencyReducer;
